import React from 'react';
import PropTypes from 'prop-types';
import s from './error-fallback.module.css';
import t from '@/i18n';
function ErrorFallback({
  errorTitle,
  errorDescription,
  buttonText,
  onFallbackButtonClick,
  id,
  ...rest
}) {
  return (
    <div className={s.container} {...rest}>
      <img src="/assets/green-exclamation-clouds.svg" alt="" />
      <p>{errorTitle}</p>
      <span>{errorDescription}</span>
      <button
        style={{
          background:
            process.env.REACT_APP_BRAND === 'baly' ? '#001FBB' : 'inherit',
        }}
        type="button"
        onClick={onFallbackButtonClick}
      >
        {buttonText || t('tryAgain')}
      </button>
      {id && (
        <span className={s.errorId}>
          Error ID:
          {id}
        </span>
      )}
    </div>
  );
}

ErrorFallback.propTypes = {
  errorTitle: PropTypes.string.isRequired,
  errorDescription: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  onFallbackButtonClick: PropTypes.func,
};

ErrorFallback.defaultProps = {
  onFallbackButtonClick: () => {},
  buttonText: null,
};

export default ErrorFallback;
